
const geturl = () => {
    return 'https://570ec0385f.pythonanywhere.com/'
}
export default geturl